import Base from './Base';
import CrmUser from '../models/CrmUser';

export default class CrmUsers extends Base {
    get models() {
        const collection = this.data.map(item => new CrmUser(item));
        collection.collection = this;

        return collection;
    }
}
